// src/components/RatePart.tsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../assets/theme";
import CustomSelect from "./common/CustomSelect";
import CustomTextField from "./common/CustomTextField";
import { BulkRateRouteRequest, RateType } from "../services/RoutingPlanDetailsService";

interface RatePartProps {
  request: Partial<BulkRateRouteRequest>;
  setRequest: React.Dispatch<React.SetStateAction<Partial<BulkRateRouteRequest>>>;
  fullWidth?: boolean;
}

const rateTypeOptions = [
  { label: "Exact Value", value: RateType.VALUE },
  { label: "Multiple of Cost", value: RateType.MULTIPLE_OF_COST },
  { label: "Add to Cost", value: RateType.ADD_TO_COST },
];

const RatePart: React.FC<RatePartProps> = ({ request, setRequest, fullWidth }) => (
  <Box
    flex={1}
    display="flex"
    flexDirection="column"
    alignItems="center"
    sx={{
      width: fullWidth ? "100%" : "auto",
      mb: { xs: 2, md: 0 },
    }}
  >
    <Typography variant="h6" mb={2}>
      Rate
    </Typography>
    <CustomSelect
      label="Rate Type*"
      bgColor={COLORS.WhiteBackground}
      fullWidth
      sx={{ mb: 2 }}
      options={rateTypeOptions}
      value={request.rateType ?? ""}
      onChange={(value) => {
        setRequest((prev) => ({
          ...prev,
          rateType: value as RateType,
        }));
      }}
    />
    <CustomTextField
      label="Rate Modifier*"
      bgColor={COLORS.WhiteBackground}
      fullWidth
      type="number"
      sx={{ mb: 2 }}
      value={request.rateModifier ?? ""}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setRequest((prev) => ({
          ...prev,
          rateModifier: newValue !== "" ? Number(newValue) : undefined,
        }));
      }}
    />
  </Box>
);

export default RatePart;
